import { render } from "./MessageCreate.vue?vue&type=template&id=9948fce2&scoped=true"
import script from "./MessageCreate.vue?vue&type=script&lang=js"
export * from "./MessageCreate.vue?vue&type=script&lang=js"

import "./MessageCreate.vue?vue&type=style&index=0&id=9948fce2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/translation_system/translation_system/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9948fce2"]])

export default __exports__